export default __webpack_public_path__ + "static/media/FoodRedistribution_YELLOW.c456d331.mp4";